/**
 * pendingDeepLinkStore — killed cold-boot 딥링크 replay 큐.
 *
 * 푸시 알림 탭 등에서 온 deep link 가 인증 부트스트랩(settle)보다 먼저 도착하면
 * protected route 가드에 막혀 손실될 수 있다. settle 전에는 여기 큐잉해 두고,
 * RootLayout 의 useDeepLinkReplay 가 settle 후 consume + navigate 한다.
 *
 * TTL(60s): 오래된 큐잉이 한참 뒤 hydration 에서 튀어나와 예상 밖 화면 점프를
 * 일으키지 않도록, consume 시점에 만료됐으면 버린다.
 */
import { create } from "zustand";

export interface PendingDeepLink {
  path: string;
  savedAt: number;
}

const PENDING_DEEP_LINK_TTL_MS = 60_000;

interface PendingDeepLinkState {
  pendingDeepLink: PendingDeepLink | null;
  setPendingDeepLink: (path: string) => void;
  /** 큐에 있던 deep link path 를 반환하며 비운다. 없거나 TTL 만료면 null. */
  consumePendingDeepLink: () => string | null;
}

export const usePendingDeepLinkStore = create<PendingDeepLinkState>((set, get) => ({
  pendingDeepLink: null,
  setPendingDeepLink: (path) =>
    set({ pendingDeepLink: { path, savedAt: Date.now() } }),
  consumePendingDeepLink: () => {
    const pending = get().pendingDeepLink;
    if (!pending) return null;
    set({ pendingDeepLink: null });
    if (Date.now() - pending.savedAt > PENDING_DEEP_LINK_TTL_MS) return null;
    return pending.path;
  },
}));
